define([
	"dojo/_base/declare",
	"csi/_base/storage",
	"csi/core/Key",
	"csi/state/rootStore",
	"csi/table/Widget"
], function(declare, storage, Key, {featureTogglesStore}, Table) {

	return declare(Table, {

		STORAGE_KEY: "LanguagesURLs",

		onViewCreate: function() {
			var key = this.STORAGE_KEY;

			this.set("activeLanguages", storage.get(key));

			this.watch("activeLanguages", function(name, oldValue, newValue) {
				storage.set(key, newValue);
			});

			this.inherited(arguments);
		},

		getPrintProperties: function() {
			// summary: return object containing properties from view necessary to recreate it for printing that are not custom view options
			var params = this.inherited(arguments);
			params.activeLanguages = this.activeLanguages;
			return params;
		},

		/**
		 * @override
		 * Hide the Composition column if the material composition feature flag is turned off
		 */
		onViewResolveKeysToSkip(skipSet) {
			if (!featureTogglesStore.MATERIAL_COMPOSITION) {
				skipSet.add(Key.untypedKeyFromParts({
					id: "SustainabilityCompositionTypes",
				}));
				skipSet.add(Key.untypedKeyFromParts({
					name: "SustainabilityCompositionMatrix",
				}));
			}
		},
	});
});